import * as React from 'react'
import { useMemo } from 'react'
import { InvoiceHeaderItemProps, useItemStyles } from './InvoiceOverview'
import useViewport, { Viewport } from '../../../hooks/useViewport'
import MoneyText from '../../../components/Text/Currency/MoneyText'
import BaseOverviewCountBadge from '../../BaseOverview/BaseOverviewCountBadge'
import InvoiceListItemTurnover from './InvoiceListItemTurnover'

export default function InvoiceHeaderItem(props: InvoiceHeaderItemProps) {
    const itemStyles = useItemStyles()
    const { viewport, isViewport } = useViewport()

    const listItemSmall = useMemo<boolean>(() => isViewport('<', Viewport.XL), [viewport])
    const listItemMedium = useMemo<boolean>(() => isViewport('>=', Viewport.XXL), [viewport])

    if (listItemSmall) {
        return (
            <>
                <BaseOverviewCountBadge {...props} />
                <div className={props.viewportTiny ? itemStyles.listInvoiceItemTinyBottomRow : itemStyles.listInvoiceItemSmallBottomRow}>
                    <div></div>
                    <div></div>
                    {!props.viewportTiny && <div></div>}
                    {!props.viewportTiny && <div></div>}
                    <div>
                        <InvoiceListItemTurnover {...props} />
                    </div>
                </div>
            </>
        )
    }

    return (
        <>
            <BaseOverviewCountBadge {...props} />
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div>
                <InvoiceListItemTurnover {...props} />
            </div>
            {listItemMedium && <div></div>}
            {listItemMedium && (
                <div>
                    {props.count.currencies?.map((currency, index) => (
                        <MoneyText
                            key={index}
                            value={{
                                currency: currency.currency,
                                amount: currency.outstandingTotal || '0.00',
                            }}
                            textProps={{
                                size: 300,
                            }}
                            align="right"
                        />
                    ))}
                </div>
            )}
            <div></div>
            <div></div>
        </>
    )
}
